export default __webpack_public_path__ + "static/media/12_linnononn.7079414f.png";